import { render, staticRenderFns } from "./newblock.vue?vue&type=template&id=eb36a7c6&"
import script from "./newblock.vue?vue&type=script&lang=js&"
export * from "./newblock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports